<template>
  <div class="main-content">
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col-12 col-md-5 col-xl-6">
          <h2 class="header-title">Cпециальность</h2>
        </div>
        <div class="col-12 col-md-7 col-xl-6 d-flex">
          <Search class="mr-2" />
        </div>
      </div>
    </div>
    <!-- Content goes Here -->
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <FotoBlock
              :imgDefault="UserImg.d"
              :iwidth="UserImg.w"
              :iheight="UserImg.h"
              @img64="foto34_filem"
              :aspectRatio="3/4"
            />

            <button class="btn btn-primary mb-4 d-block" @click="sendFoto">
              Отправвить
            </button>

            <!-- <button class="btn btn-primary mb-4 d-block" @click="notificat">Уведомления</button> -->
            <button
              class="btn btn-primary mb-4 d-block"
              @click="generateReport"
            >
              VueHtml2pdf
            </button>
            <button class="btn btn-primary mb-4 d-block" @click="startDownload">
              werwerw
            </button>
            <button
              class="btn btn-primary mb-4 d-block"
              @click="
                notificate(
                  'Успешно сахранено Успешно сахранено Успешно сахранено Успешно сахранено',
                  'success'
                )
              "
            >
              notificate
            </button>
            <button
              class="btn btn-primary mb-4 d-block"
              @click="notificate('Ошибка сахранения', 'danger')"
            >
              notificate
            </button>
            <button
              class="btn btn-primary mb-4 d-block"
              @click="notificate('Пркдупреждения', 'warning')"
            >
              notificate
            </button>
            <button class="btn btn-primary mb-4 d-block" @click="nnn()">
              nnn
            </button>
            <div>
              <label>Email</label>
              <input type="text" v-model="user.email" />
            </div>
            <div v-for="role in roles" :key="role.id">
              <label>{{role.name}}</label>
              <input type="checkbox" v-model="user.roles" :value="role"/>
            </div>
          </div>
          <div class="col">
            <div class="crop">
              <cropper
                :src="img"
                class="cropper mb-2"
                :stencil-props="{
                  aspectRatio: 3/4
                }"
                :auto-zoom="true" 
                ref="cropper"               
                
              />
              
            </div>
            <div class="text-right">
                <div type="button" class="btn btn-primary" @click="imgCrop">Обрезать</div>
              </div>
            <img
              :src="UserImg.d"
              alt=""
              width="120px"
              height="152px"
              style="border: 1px dashed gray"
            />
          </div>
          <div class="col">
            
            <div ref="imfBlock"></div>
          </div>
          <div class="col">
            <canvas ref="canvas"></canvas>
          </div>
        </div>

        <hr />
      </div>
    </div>

    <template>
      <div>
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="01"
          :pdf-quality="3"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          ref="html2Pdf"
        >
          <section slot="pdf-content">
            <div class="pdfContainer">
              <div class="row mb-3">
                <div class="col">
                  <img
                    src="https://registration.portal.oshsu.kg/storage/photo34/6_1_1654679983_image.png"
                    class="userFoto"
                  />
                </div>
                <div class="col text-center align-self-end">
                  <h2>Арыз</h2>
                </div>
                <div class="col">
                  <div class="text-right">
                    <b>Ош мамлекеттик <br />университетинин ректоруна</b
                    ><br /><br />
                    Рег. № 123
                  </div>
                </div>
              </div>
              <div>
                <span>Мени ОшМУнун</span>
                <span class="text_v px-3"
                  >КЫРГЫЗ ФИЛОЛОГИЯСЫ ЖАНА ЖУРНАЛИСТИКА</span
                >
                <span>факультетинин</span>
              </div>
              <div class="">
                <span class="text_v pr-3">Филологиялык билим берүү</span>
                <span>адистиги/багыты боюнча кабыл алуунузду суранам</span>
              </div>
              <hr />
              <div class="d-flex mb-2">
                <div class="info_block">
                  <span>Окуу формасы:</span>
                  <span class="text_v mx-2">Кундузгу</span>
                </div>
                <div class="info_block">
                  <span>Окуу тиби:</span>
                  <span class="text_v mx-2">Бюджет</span>
                </div>
                <div class="info_block">
                  <span>Окуу тили:</span>
                  <span class="text_v mx-2">Кыргызча</span>
                </div>
              </div>
              <div class="section mb-3">Озум жонундо маалымат</div>
              <div class="row mb-2">
                <div class="col br">
                  <div class="info_item">
                    <span>Фамилясы:</span>
                    <span class="text_v mx-2">Эгешов</span>
                  </div>
                  <div class="info_item">
                    <span>Аты:</span>
                    <span class="text_v mx-2">Арген</span>
                  </div>
                  <div class="info_item">
                    <span>Отчество:</span>
                    <span class="text_v mx-2">Мусаевич</span>
                  </div>
                </div>
                <div class="col">
                  <div class="info_item">
                    <span>Туулган куну:</span>
                    <span class="px-2">01.02.2000</span>
                  </div>
                  <div class="info_item">
                    <span>Жынысы:</span>
                    <span class="text_v mx-2">Эркек</span>
                  </div>
                  <div class="info_item">
                    <span>Улуту:</span>
                    <span class="text_v mx-2">Кыргыз</span>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row">
                <div class="col">
                  <div class="text_v mr-2">Паспорт Серия/№:</div>
                  <div>1234567890</div>
                </div>
                <div class="col">
                  <div class="col">
                    <div class="text_v mr-2">Берген орган, датасы:</div>
                    <div>МКК 03.05.2000</div>
                  </div>
                </div>
                <div class="col">
                  <div class="col">
                    <div class="text_v mr-2">Жеке идент. номер (ПИН)</div>
                    <div>12345678901233454567</div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="info_item mb-2">
                <span class="text_v mr-2">Туулган жери:</span>
                <span>Баткен областы, Баткен району, Коншу айылы</span>
              </div>

              <div class="section mb-3">
                Бүтүргөн мектеби/окуу жайы боюнча маалымат
              </div>
              <div class="row mb-2">
                <div class="col-5 br">
                  <div class="info_item">
                    <span>Мамлекет:</span>
                    <span class="text_v mx-2">Кыргызстан</span>
                  </div>
                  <div class="info_item">
                    <span>Область:</span>
                    <span class="text_v mx-2">Жалалабад</span>
                  </div>
                  <div class="info_item">
                    <span>Шаар / Район:</span>
                    <span class="text_v mx-2">Базаркоргон</span>
                  </div>
                </div>
                <div class="col-7">
                  <div class="info_item">
                    <span>Мектептин аталышы:</span>
                    <span class="text_v px-2">Ленин комсомол</span>
                  </div>
                  <div class="info_item">
                    <span>Аттестат/диплом серия, №:</span>
                    <span class="mx-2">1234567890</span>
                  </div>
                  <div class="row">
                    <div class="col">
                      <div class="info_item">
                        <span>Бүтүргөн жылы:</span>
                        <span class="mx-2">2022</span>
                      </div>
                    </div>
                    <div class="col">
                      <div class="info_item">
                        <span>Окуган чет тили:</span>
                        <span class="text_v mx-2">Англисче</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="section mb-3">ОРТ боюнча маалымат</div>
              <div class="row">
                <div class="col-4">
                  <div class="info_item">
                    <span>Сертификат №:</span>
                    <span class="text_v mx-2">1234567890</span>
                  </div>
                </div>
                <div class="col-5">
                  <div class="info_item">
                    <span>Категория:</span>
                    <span class="text_v mx-2">Бийик тоолу</span>
                  </div>
                </div>
                <div class="col-3">
                  <div class="info_item">
                    <span>Негизги баллы:</span>
                    <span class="text_v mx-2">300</span>
                  </div>
                </div>
              </div>
              <hr />
              <div class="row mb-2">
                <div class="col">
                  <div class="info_item">
                    <span>Кошумча предмет(<b>Химия</b>):</span>
                    <span class="mx-2">200 бал</span>
                  </div>
                </div>
                <div class="col">
                  <div class="info_item">
                    <span>Кошумча предмет(<b>Биология</b>):</span>
                    <span class="text_v mx-2">150 балл</span>
                  </div>
                </div>
              </div>
              <div class="section mb-3">Аскердик билет/Приписной(Күбөлүк)</div>
              <div class="d-flex justify-content-between mb-2">
                <div class="info_item">
                  <span>Серия/№:</span>
                  <span class="mx-2">1234567890</span>
                </div>

                <div class="info_item">
                  <span>Берилген датасы / Берген орган:</span>
                  <span class="mx-2">MKK 03.06.2022</span>
                </div>
              </div>
              <div class="section mb-3">Ата-энеси жөнүндө маалымат</div>
              <div class="info_item">
                <span>Атасы:</span>
                <span class="mx-2">Манас Ташмат Полотович (0123456789)</span>
              </div>
              <div class="info_item">
                <span>Апасы:</span>
                <span class="mx-2">Каныкей Ташмата Полотовна (0123456789)</span>
              </div>

              <div class="info_sm">
                Жожго кабыл алуунун эрежеси, билим берүү укугуна күбөлөнтүрүүчү
                лицензия менен тааныштым, жеке маалыматтарды иштетүүгө
                макулдугум бергем
              </div>

              <div class="d-flex justify-content-between">
                <div class="info_item">
                  <span>Арыз толтурулган датасы:</span>
                  <span class="mx-2">03.06.2022</span>
                </div>
                <div class="info_item">
                  <span>Абитуриенттин колу:</span>
                  <span class="">_______________</span>
                </div>
              </div>
              <div class="d-flex justify-content-between">
                <div class="info_item">
                  <span>Квитанция №:</span>
                  <span class="mx-2">_________________________________</span>
                </div>
                <div class="info_item">
                  <span>Төлөгөн датасы:</span>
                  <span class="">_______________</span>
                </div>
              </div>
            </div>
          </section>
        </vue-html2pdf>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

import Search from "@/components/others/Search.vue";
import FotoBlock from "@/components/others/FotoBlock2.vue";
import VueHtml2pdf from "vue-html2pdf";

import { Cropper } from 'vue-advanced-cropper';

export default {
  name: "Temp",
  components: {
    Search,
    FotoBlock,
    VueHtml2pdf,
    Cropper
  },
  data() {
    return {
      img: 'https://fakeimg.pl/600x900/?text=Hello',
      UserImg: { img: null, d: null, w: "120px", h: "152px" },
      isModalShow: false,
      fak: { disabled: true, items: null, val: 0 },
      direction: { disabled: true, items: null, val: 0 },
      spec: {
        disabled: true,
        items: null,
        val: {
          kg: "",
          ru: "",
          en: "",
        },
      },
      downloadedImg: null,
      cnv: null,
      imagePDF: null,
      user: {
        email: 'test@test.com',
        roles: [{id: 1, name: 'Client'}]
      },
      roles: [
        {
          id: 1,
          name: 'Client',
        },
        {
          id: 2,
          name: 'Admin',
        },
        {
          id: 3,
          name: 'Guest',
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      getUser: "user/getUser",
      getMSG: "notificate/getMSG",
    }),
  },
  methods: {
    imgCrop() {
      const {visibleArea, canvas} = this.$refs.cropper.getResult();
      let dataURL = canvas.toDataURL("image/png");
      this.cropImage = dataURL;
      let vm = this;
      this.urltoFile(dataURL, "image.png", "image/png").then(function (file) {
        vm.imgSend(file);
      });
      this.viewModalShow();
      console.log(dataURL, visibleArea);
		},
    nnn() {
      this.$nt("Успешно сахранено", "success");
    },
    ...mapActions({
      setMSG: "notificate/setMSG",
    }),
    notificate(message, status) {
      this.setMSG({
        id: Date.now().toString(),
        name: message,
        status: status,
      });
    },
    startDownload() {
      let imageURL =
        "https://registration.portal.oshsu.kg/storage/photo34/6_1_1654679983_image.png";

      this.downloadedImg = new Image();
      this.downloadedImg.width = 120;
      // this.downloadedImg.crossOrigin = "Anonymous";
      this.downloadedImg.addEventListener("load", this.imageReceived, false);
      this.downloadedImg.src = imageURL;
      console.log(this.downloadedImg.src);
    },
    imageReceived() {
      this.$refs.imfBlock.appendChild(this.downloadedImg);

      // var canvas = document.createElement("canvas");
      this.cnv.width = this.downloadedImg.width;
      this.cnv.height = this.downloadedImg.height;
      let ctx = this.$refs.canvas.getContext("2d");
      ctx.drawImage(this.downloadedImg, 0, 0, this.cnv.width, this.cnv.height);
      // this.$refs.imfBlock.appendChild(canvas);
      let dataURL = this.cnv.toDataURL("image/png");
      console.log(this.cnv.toDataURL("image/png"));
      try {
        console.log(dataURL);
      } catch (error) {
        console.log(error);
      }

      // let canvas = document.createElement("canvas");
      // let context = canvas.getContext("2d");

      // canvas.width = this.downloadedImg.width;
      // canvas.height = this.downloadedImg.height;

      // context.drawImage(this.downloadedImg, 0, 0);
      // imageBox.appendChild(canvas);
    },
    toDataURL(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },

    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },

    foto34_filem(file) {
      this.UserImg.img = file;
      console.log(file);
    },
    sendFoto() {
      this.UserImg.d =
        "https://registration.portal.oshsu.kg/storage/photo34/6_1_1654679983_image.png";
      console.log(this.UserImg.d);
    },
    async chek_document() {
      try {
        const data = (
          await this.$api.documents.chek_document({
            id_document: 1,
            token: this.getUser.token,
          })
        ).data;

        return data;
      } catch (error) {
        console.log(error);
      }
    },
  },

  mounted() {
    this.chek_document().then((data) => {
      this.UserImg.d =
        "https://registration.portal.oshsu.kg/storage/photo34/" +
        data.document_file.foto34_file;
    });
    this.cnv = this.$refs.canvas;
  },
};
</script>
<style lang="scss" scoped>
td:last-child {
  word-wrap: none;
}
.pdfContainer {
  color: #000;
  padding: 35px;
  .userFoto {
    width: 100px;
    border: 1px dashed gray;
    padding: 3px;
  }
  .text_v {
    font-weight: 600;
  }
  hr {
    border-top: 1px solid #c9c9c9;
    margin-top: 10px;
    margin-bottom: 7px;
  }
  .info_block {
    margin-right: 1.5em;
  }
  .br {
    border-right: 1px solid #c9c9c9;
  }
  .section {
    background-color: rgb(83, 83, 83);
    color: #fff;
    padding: 5px;
    text-align: center;
  }
  .info_sm {
    font-size: 12px;
    color: #555;
    line-height: 15px;
    padding: 5px 0;
    border-top: 1px dashed #c9c9c9;
    border-bottom: 1px dashed #c9c9c9;
    margin: 15px 0;
  }
}
</style>
